/**
 * Shared grid template for the sub-goal table.
 *
 * Both the header row (in RevenuePillar) and the data rows (SubGoalRow) use
 * this exact string so their columns align pixel-perfectly. Previously the
 * template used `minmax(Xpx, Yfr)` which let content force columns wider
 * than their fr-calculated width — creating a subtle drift between the
 * header grid and the data-row grid.
 *
 * Columns:
 *   1. Sub-Goal (flexible, ~1.8fr)
 *   2. Owner dropdown (95px — fits "Christina ▼")
 *   3. Current (80px)
 *   4. Target (80px)
 *   5. Progress bar (130px)
 *   6. % (44px, right-aligned)
 *   7. Update textarea (flexible, ~1.6fr)
 *   8. Comment + Reaction bubbles (64px — side-by-side, icon-only)
 *
 * The delete × on each row is absolute-positioned outside this grid
 * (top-right of the row, visible on row hover).
 */
export const SUBGOAL_GRID = '1.8fr 95px 80px 80px 130px 44px 1.6fr 64px'
